import {
  LANGUAGE_SELECTOR_SELECT,
  LANGUAGE_SELECTOR_MOVE_UP,
  LANGUAGE_SELECTOR_MOVE_DOWN,
  LANGUAGE_SELECTOR_REMOVE,
  LANGUAGE_SELECTOR_SAVE,
  LANGUAGE_SELECTOR_ENABLE_FLAG,
} from './action-names';

export function select(data) {
  return {
    type: LANGUAGE_SELECTOR_SELECT,
    ...data
  };
};

export function moveUp(data) {
  return {
    type: LANGUAGE_SELECTOR_MOVE_UP,
    ...data
  };
};

export function moveDown(data) {
  return {
    type: LANGUAGE_SELECTOR_MOVE_DOWN,
    ...data
  };
};

export function remove(data) {
  return {
    type: LANGUAGE_SELECTOR_REMOVE,
    ...data
  };
};

export function save(data) {
  return {
    type: LANGUAGE_SELECTOR_SAVE,
    ...data
  };
};

export function setEnableFlag(data) {
  return {
    type: LANGUAGE_SELECTOR_ENABLE_FLAG,
    ...data
  };
};



// WEBPACK FOOTER //
// ./app/header-builder/actions/language-element-actions.js